module.exports = __webpack_public_path__ + "media/images/ecalls/icon_monitor_ice-efb87a5deb772901fadf3731f9cdf3ac.png";